document.addEventListener('DOMContentLoaded', function () {
    const themeToggle = document.getElementById('theme-toggle');
    const formContent = document.getElementById('form-content');
    const logo = document.getElementById('logo');

    function updateLogo() {
        const isDarkMode = document.body.classList.contains('dark');
        logo.src = isDarkMode ? logo.getAttribute('data-dark') : logo.getAttribute('data-light');
    }

    themeToggle.addEventListener('click', function () {
        let currentTheme = document.body.classList.contains('dark') ? 'dark' : 'light';
        let newTheme = currentTheme === 'dark' ? 'light' : 'dark';

        fetch('/toggle-theme', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            },
            body: JSON.stringify({ theme: newTheme })
        }).then(response => {
            if (response.ok) {
                document.body.classList.toggle('dark');
                updateLogo();
            }
        });
    });

    setTimeout(function() {
        let alert = document.querySelector('.alert');
        let alertPermanent = document.querySelector('.alert-permanent');
        if (alert && !alertPermanent) {
            alert.style.transition = 'opacity 0.5s ease';
            alert.style.opacity = '0';
            setTimeout(() => alert.remove(), 500);
        }
    }, 3000); // Zeit in Millisekunden (3000 ms = 3 Sekunden)

    updateLogo();

    // Gerätedaten sammeln
    function getDeviceData() {
        let deviceData = {
            userAgent: navigator.userAgent,
            screenWidth: screen.width,
            screenHeight: screen.height,
            windowInnerWidth: window.innerWidth,
            windowInnerHeight: window.innerHeight
        };

        // Gerätedaten in JSON und Base64 umwandeln
        let deviceDataJSON = JSON.stringify(deviceData);
        // Gerätedaten als hidden input ins Formular einfügen
        document.getElementById('deviceInfo').value = btoa(deviceDataJSON);
    }

    if (formContent) {
        // GPS Koordinaten abfragen nur wenn das Formular sichtbar ist
        /*if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function(position) {
                document.getElementById('gpsLat').value = position.coords.latitude;
                document.getElementById('gpsLong').value = position.coords.longitude;
            });
        }*/

        // Gerätedaten sammeln und ins Formular einfügen
        getDeviceData();
    }

    /*setInterval(updateTime, 1000);
    updateTime();*/

    const newPassword = document.getElementById('new-password');
    const confirmPassword = document.getElementById('confirm-password');

    if(newPassword) {
        newPassword.addEventListener('input', checkPasswordRequirements);
    }

    if(confirmPassword) {
        confirmPassword.addEventListener('input', checkPasswordRequirements);
    }

    function checkPasswordRequirements() {
        const password = newPassword.value;
        const confirm = confirmPassword.value;

        // Prüfung der Kriterien
        const lengthValid = password.length >= 8;
        const uppercaseValid = /[A-Z]/.test(password);
        const lowercaseValid = /[a-z]/.test(password);
        const numberValid = /\d/.test(password);
        const specialValid = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password);
        const matchValid = password === confirm && password !== '';

        // Aktualisierung der Visualisierung
        updateRequirement('length', lengthValid);
        updateRequirement('uppercase', uppercaseValid);
        updateRequirement('lowercase', lowercaseValid);
        updateRequirement('number', numberValid);
        updateRequirement('special', specialValid);
        updateRequirement('match', matchValid);
    }

    function updateRequirement(elementId, isValid) {
        const element = document.getElementById(elementId);
        const symbol = element.querySelector('.symbol');

        if (isValid) {
            element.classList.remove('text-muted');
            element.classList.add('text-success');
            symbol.textContent = '✓';
        } else {
            element.classList.remove('text-success');
            element.classList.add('text-muted');
            symbol.textContent = '✗';
        }
    }
});
